import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { AttributeLabelPipe } from '@df/ui/common/attribute-label.pipe';
import { findMediaByLabel } from '@df/ui/common/find-media-by-label.pipe';
import { ProductLayoutDetailsGeneralItemComponent } from '../item/product-layout-details-general-item.component';
import { ProductLayoutDetailsGeneralAbstractComponent } from '../product-layout-details-general.abstract';

@Component({
    selector: 'product-layout-details-general-dimensions',
    templateUrl: './product-layout-details-general-dimensions.component.html',
    imports: [AttributeLabelPipe, CommonModule, DfImageDirective, ProductLayoutDetailsGeneralItemComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductLayoutDetailsGeneralDimensionsComponent extends ProductLayoutDetailsGeneralAbstractComponent {
    protected override readonly attribute = 'dimensionsAttributes';

    get image() {
        const media = this.productViewLayout().product()?.data?.media;

        if (media) {
            return findMediaByLabel(media, ['dimensions']);
        }

        return null;
    }
}
